<template>
    <div class="app-content">
        <side-bar></side-bar>
        <div class="main-container" :style="{ width: widthStyle }">
            <div class="fixed-header dynamic" :style="{ width: widthStyle }">
                <navbar />
            </div>
            <app-main />
        </div>
        <el-backtop target=".main-container" :visibility-height="100"></el-backtop>
    </div>
</template>
<script setup>
import { onBeforeRouteUpdate } from 'vue-router';
import SideBar from './sidebar.vue';
import AppMain from './appMain.vue';
import Navbar from './navbar.vue';
import cookie from '@/commons/cookie.js';
import { computed, watchEffect, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
onBeforeRouteUpdate((to, from, next) => {
    // 调用 next() 来继续路由导航
    if (!cookie.getCookie('token') && to.name !== 'login') {
        next('/login');
    } else {
        next();
    }
});
const router = useRouter();
if (!cookie.getCookie('token')) {
    router.push('/login');
}
const store = useStore();
const opened = computed(() => store.state.app.sidebar.opened);
const widthStyle = ref('calc(100% - 200px)');
watchEffect(() => {
    widthStyle.value = !opened.value ? 'calc(100% - 64px)' : 'calc(100% - 200px)';
});
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
}
.app-content {
    height: 100%;
    display: flex;
    background-color: #f0f2f5;
    overflow: hidden;
    .main-container {
        overflow-y: auto;
        overflow-x: hidden;
        width: calc(100% - #{$sideBarWidth});
    }
}
</style>
